import { Link } from 'react-router-dom'
import { Shield } from 'lucide-react'

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-kiniela-bg py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <div className="bg-kiniela-accent/20 p-4 rounded-full border border-kiniela-border">
              <Shield className="h-12 w-12 text-kiniela-gold" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-kiniela-gold mb-4">
            Aviso de Privacidad Integral
          </h1>
          <p className="text-kiniela-muted">
            Última actualización: Febrero 2026
          </p>
        </div>

        {/* Content */}
        <div className="bg-kiniela-card rounded-xl border border-kiniela-border p-8 space-y-8">
          {/* Section 1 */}
          <section>
            <h2 className="text-2xl font-bold text-kiniela-gold mb-4">
              1. Responsable del tratamiento de datos personales
            </h2>
            <div className="text-kiniela-text space-y-3">
              <p>
                Kiniela, con domicilio en el Estado de Jalisco, México (en adelante "Kiniela"), es responsable del tratamiento de los datos personales que recaba a través de su plataforma digital disponible en:
              </p>
              <p className="text-kiniela-gold font-semibold">
                https://kiniela.mx
              </p>
              <p>
                Para cualquier asunto relacionado con la protección de datos personales, puede contactarnos en:
              </p>
              <p className="text-kiniela-gold">
                📧 soporte@kiniela.mx
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-2xl font-bold text-kiniela-gold mb-4">
              2. Datos personales que recabamos
            </h2>
            <div className="text-kiniela-text space-y-4">
              <p>
                Para el registro y uso de la plataforma, Kiniela podrá recabar los siguientes datos personales:
              </p>
              
              <div>
                <h3 className="font-semibold text-kiniela-text mb-2">Datos de identificación:</h3>
                <ul className="list-disc list-inside text-kiniela-muted space-y-1 ml-4">
                  <li>Nombre completo</li>
                  <li>Fecha de nacimiento</li>
                  <li>Identificación oficial (INE)</li>
                  <li>Fotografía contenida en la identificación</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-kiniela-text mb-2">Datos de contacto:</h3>
                <ul className="list-disc list-inside text-kiniela-muted space-y-1 ml-4">
                  <li>Correo electrónico</li>
                  <li>Número telefónico</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-kiniela-text mb-2">Datos financieros:</h3>
                <ul className="list-disc list-inside text-kiniela-muted space-y-1 ml-4">
                  <li>Información relacionada con depósitos y retiros</li>
                  <li>CLABE interbancaria (en caso de retiros)</li>
                </ul>
              </div>

              <p className="text-kiniela-muted">
                No recabamos datos personales sensibles adicionales a los estrictamente necesarios para validar identidad.
              </p>
            </div>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-2xl font-bold text-kiniela-gold mb-4">
              3. Finalidades del tratamiento
            </h2>
            <div className="text-kiniela-text space-y-4">
              <div>
                <h3 className="font-semibold text-kiniela-text mb-2">Finalidades primarias:</h3>
                <ul className="list-disc list-inside text-kiniela-muted space-y-1 ml-4">
                  <li>Crear y administrar su cuenta de usuario</li>
                  <li>Verificar su identidad (proceso KYC)</li>
                  <li>Confirmar que es mayor de 18 años</li>
                  <li>Procesar depósitos y retiros</li>
                  <li>Prevenir fraude, colusión o uso indebido de la plataforma</li>
                  <li>Cumplir obligaciones legales aplicables</li>
                  <li>Atender solicitudes, dudas o aclaraciones</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-kiniela-text mb-2">Finalidades secundarias (opcionales):</h3>
                <ul className="list-disc list-inside text-kiniela-muted space-y-1 ml-4">
                  <li>Envío de información sobre nuevas jornadas, promociones o actualizaciones</li>
                </ul>
                <p className="text-kiniela-muted mt-2">
                  Si no desea que sus datos sean utilizados para finalidades secundarias, puede solicitarlo mediante correo electrónico.
                </p>
              </div>
            </div>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-2xl font-bold text-kiniela-gold mb-4">
              4. Transferencia de datos
            </h2>
            <div className="text-kiniela-text space-y-3">
              <p>
                Kiniela podrá compartir datos personales únicamente cuando sea necesario para:
              </p>
              <ul className="list-disc list-inside text-kiniela-muted space-y-1 ml-4">
                <li>Procesamiento de pagos (Mercado Pago, instituciones bancarias)</li>
                <li>Cumplimiento de obligaciones legales ante autoridades competentes</li>
                <li>Prevención de fraude o actividades ilícitas</li>
              </ul>
              <p className="text-kiniela-muted">
                En ningún caso comercializamos ni vendemos datos personales.
              </p>
            </div>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-2xl font-bold text-kiniela-gold mb-4">
              5. Medidas de seguridad
            </h2>
            <div className="text-kiniela-text space-y-3">
              <p>
                Kiniela implementa medidas administrativas, técnicas y físicas razonables para proteger los datos personales contra:
              </p>
              <ul className="list-disc list-inside text-kiniela-muted space-y-1 ml-4">
                <li>Acceso no autorizado</li>
                <li>Uso indebido</li>
                <li>Pérdida o alteración</li>
              </ul>
              <p className="text-kiniela-muted">
                El acceso a documentación de identificación está restringido y protegido.
              </p>
            </div>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-2xl font-bold text-kiniela-gold mb-4">
              6. Derechos ARCO
            </h2>
            <div className="text-kiniela-text space-y-3">
              <p>Usted tiene derecho a:</p>
              <ul className="list-disc list-inside text-kiniela-muted space-y-1 ml-4">
                <li>Acceder a sus datos personales</li>
                <li>Rectificarlos si son inexactos</li>
                <li>Cancelarlos cuando considere que no son necesarios</li>
                <li>Oponerse a su tratamiento para fines específicos</li>
              </ul>
              <p>
                Para ejercer sus derechos ARCO deberá enviar solicitud al correo:
              </p>
              <p className="text-kiniela-gold">
                📧 soporte@kiniela.mx
              </p>
              <div>
                <p className="mb-2">La solicitud deberá incluir:</p>
                <ul className="list-disc list-inside text-kiniela-muted space-y-1 ml-4">
                  <li>Nombre completo</li>
                  <li>Medio para recibir respuesta</li>
                  <li>Descripción clara del derecho que desea ejercer</li>
                  <li>Documento que acredite identidad</li>
                </ul>
              </div>
              <p className="text-kiniela-muted">
                Responderemos en un plazo máximo de 20 días hábiles conforme a la legislación aplicable.
              </p>
            </div>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-2xl font-bold text-kiniela-gold mb-4">
              7. Revocación del consentimiento
            </h2>
            <div className="text-kiniela-text space-y-3">
              <p>
                Usted puede revocar el consentimiento para el tratamiento de sus datos enviando solicitud al correo indicado.
              </p>
              <p className="text-kiniela-muted">
                La revocación no tendrá efectos retroactivos y puede implicar la cancelación de su cuenta.
              </p>
            </div>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="text-2xl font-bold text-kiniela-gold mb-4">
              8. Uso de cookies
            </h2>
            <div className="text-kiniela-text space-y-3">
              <p>La plataforma puede utilizar cookies y tecnologías similares para:</p>
              <ul className="list-disc list-inside text-kiniela-muted space-y-1 ml-4">
                <li>Mejorar experiencia de usuario</li>
                <li>Mantener sesión activa</li>
                <li>Analizar funcionamiento del sistema</li>
              </ul>
              <p className="text-kiniela-muted">
                Puede deshabilitarlas desde su navegador.
              </p>
            </div>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="text-2xl font-bold text-kiniela-gold mb-4">
              9. Conservación de datos
            </h2>
            <div className="text-kiniela-text">
              <p>
                Sus datos serán conservados durante el tiempo que mantenga activa su cuenta y el necesario para cumplir obligaciones legales o resolver controversias.
              </p>
            </div>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="text-2xl font-bold text-kiniela-gold mb-4">
              10. Cambios al Aviso de Privacidad
            </h2>
            <div className="text-kiniela-text space-y-3">
              <p>
                Kiniela podrá modificar este Aviso en cualquier momento.
                Las actualizaciones serán publicadas en la plataforma.
              </p>
            </div>
          </section>
        </div>

        {/* Back Button */}
        <div className="mt-8 text-center">
          <Link 
            to="/" 
            className="inline-block k-btn-secondary"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  )
}
